import React, { useRef, useState, useEffect } from 'react';

import SiteModuleContents from '../../components/manageRoles/SiteModuleContents';
import { useSmarkDispatch, useSmarkState } from '../../Context/KeycloakContext';
import Header from '../../components/header/headercontainer';
const Roles= (props) => {
    const contextDetails = useSmarkState();
    
  

    return (
        <div>
            
            <SiteModuleContents isAdmin={contextDetails.isAdminUser} userId={contextDetails.userId}></SiteModuleContents>
            
      </div>
        
    )
}

export default Roles;
